import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { requestPurchaseList, requestPurchaseDelete } from "../../Redux/actions";
import Footer from './../footer';
import PageHeader from './../header';
import Sidebar from './../Sidebar';
import '../../Admin/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//import { DataTable, Header, HeaderRow, HeaderCell, Body, Row, Cell, } from '@table-library/react-table-library/table';
import DataTable from 'react-data-table-component';
import { addDegreeAdmin } from "../../Redux/sagas";

function PurchaseList(props) {
    const params = useParams();
    const [jobs, setjobs] = useState([]);
    // const [pagination, setpagination] = useState({});
    const navigate = useNavigate();
    const [pages, setpages] = useState([]);
    const [page_size, setpage_size] = useState(10);
    const [change, setchange] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);
    const [logindetails, setlogindetails] = useState({});
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [checked_all, setCheckedAll] = useState(false);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const HandlyAddCart = () => {
        navigate('/purchaseadd');
    }

    // Function to handle individual checkbox change
    const handleCheckboxChange = (id) => {
        console.log("Checkbox clicked:", id);
        const updatedCheckboxes = selectedCheckboxes.includes(id)
            ? selectedCheckboxes.filter((checkboxId) => checkboxId !== id)
            : [...selectedCheckboxes, id];
        setSelectedCheckboxes(updatedCheckboxes);
    };

    const Checkbox = ({ id, isChecked, onChange, name, value }) => (
        <input type="checkbox" name={name} value={value} id={id} checked={isChecked} onChange={() => onChange(id)} />
    );

    // Function to handle "Select All" checkbox change
    const handleSelectAllChange = () => {
        const allCheckboxIds = filter.map((item) => item.cartId);
        setSelectedCheckboxes((prevSelected) =>
            prevSelected.length === allCheckboxIds.length ? [] : allCheckboxIds
        );
    };

    const handleSearch = (event) => {
        console.log(event.target.value);
        setSearch(event.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    const columns = [
        {
            name: 'Select',
            cell: item => <div>
                <Checkbox id={item.Id} name="select" value={item.Id} onChange={() => handleCheckboxChange(item.Id)} isChecked={selectedCheckboxes.includes(item.Id)}></Checkbox>
            </div>,
            selector: item => item.Id,
            width: '1%'
        },
        {
            name: 'Name',
            cell: item => <div><h6>{item.name}</h6></div>,
            selector: item => item.name,
            width: '15%'
        },
        {
            name: 'Bill Details',
            cell: item => <div><h6>{item.billNo}</h6><p>{item.billDate}</p></div>,
            selector: item => item.billNo,
            width: '15%'
        },
        {
            name: 'Amount',
            cell: item => <div><h6>{item.grandtotal}</h6><p>Paid: {item.paid}</p><p>{item.balance}</p></div>,
            selector: item => item.grandtotal,
            width: '10%'
        },
        {
            name: 'Action',
            cell: item => <div>
                <button class="badge badge-opacity-warning" style={{ border: "0px", marginLeft: "5px", }}
                ><i className="fa fa-edit"></i></button>
                <button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                    onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button>
            </div>,
            selector: item => item.id,
            width: '100px'
        },
    ];

    function deletedata(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestPurchaseDelete({
                    data: {
                        token: logindetails.data.userToken,
                        param1: id.toString()
                    },
                });
            }
        })
    }

    //delete
    useEffect(() => {
        let deleteData = props.data.purchaseDeleteData;
        if (deleteData !== undefined) {
            if (deleteData.data.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: deleteData.data.message,
                    icon: 'success'
                });
                setchange(!change)
            }
            else {
                Swal.fire({
                    title: 'Error!',
                    text: deleteData.data.message,
                    icon: 'error'
                })
            }
        }
        props.data.purchaseDeleteData = undefined;
        deleteData = undefined;
    }, [props.data.purchaseDeleteData]);

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            props.requestPurchaseList({
                //      token: localStorage.getItem('companyToken'),
                token: '611337539322',
                page: params.page,
                page_size: params.page_size,
                search: 'a'
            });
        }
        setpage_size(params.page_size);
    }, [params.page, params.page_size, change]);

    function onChangePageSize(e) {
        setpage_size(e.target.value);
        if (e.target.value > 0) {
            navigate(`/purchaselist/1/${e.target.value}`);
        }
    }

    //set job list
    useEffect(() => {
        let jobsData = props.data.purchaseListData;
        console.log(jobsData);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                setjobs(jobsData.data.data);
                setFilter(jobsData.data.data);
                // setTotalRows(jobsData.data.meta.total);
            }
        }
    }, [props.data.purchaseListData]);

    const handlePageChange = page => {
        console.log(page);
        props.requestPurchaseList({
            page: page,
            page_size: page_size,
            search: 'a'
        });
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setpage_size(newPerPage);
        props.requestPurchaseList({
            page: page,
            page_size: newPerPage,
            search: 'a'
        });
    }

    function printPage() {
        var printContents = "<br/><center><h3>Jobs</h3></center>" + document.getElementById("printme").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    }

    return (
        <>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="col-12 grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="card-body">
                                                        <div class="d-sm-flex justify-content-between align-items-start">
                                                            <div class="btn-wrapper">
                                                                <RWebShare
                                                                    data={{
                                                                        text: "BookkeeperDay - Your Personal Bookkeeping App",
                                                                        url: `${baseUrl}/cart/${params.page}/${params.page_size}`,
                                                                        title: "Cart List",
                                                                    }}
                                                                >
                                                                    <p class="btn btn-otline-dark align-items-center"><i class="icon-share"></i> Share</p>
                                                                </RWebShare>
                                                                <button onClick={printPage} class="btn btn-otline-dark"><i class="icon-printer"></i> Print</button>
                                                            </div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-body">
                                                                <button class="btn btn-primary" style={{ color: '#fff' }} onClick={() => { HandlyAddCart(); }}>Add Purchase</button>
                                                            </div>
                                                        </div>
                                                        <div class="table-responsive  mt-1" id="printme">
                                                            <DataTable
                                                                columns={columns}
                                                                data={filter}
                                                                pagination
                                                                paginationServer
                                                                paginationTotalRows={totalRows}
                                                                onChangePage={handlePageChange}
                                                                onChangeRowsPerPage={handlePerRowsChange}
                                                                actions={<button className="btn btn-success">Export to PDF</button>}
                                                                subHeader
                                                                subHeaderComponent={
                                                                    <input id="search" type="text" className="w-25 form-control" placeholder="Search..." value={search} onChange={handleSearch} />
                                                                }
                                                                customStyles={tableHeaderStyle}
                                                            // conditionalRowStyles={conditionalRowStyles}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <Footer /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestPurchaseList, requestPurchaseDelete }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseList);